import Uint8Array from "./component-library442.mjs";
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}
export {
  cloneArrayBuffer as default
};
